import { makeService } from './api';

const service = makeService('payments');

export default service;